import apiClient from "../../apiClient";
import { CREATE_TAG, TAG_LIST } from "../../apiClient/apiEndpoints";
import { assetFilterId } from "../../env";
import { addAssetTags, addModuleXRTags } from "../../store/slice/tagsSlice";
import { store } from "../../store/store";
import { toastError } from "./toast";

export const assetTypeKeys = {
    "MODULE.ASSET.WEB": "web",
    "MODULE.ASSET.MOBILE": "mobile",
    "MODULE.ASSET.STANDALONE.VR": "standalonevr",
    "MODULE.ASSET.DESKTOP": "desktop",
    "MODULE.ASSET.DESKTOP.VR": "desktopvr",
    "MODULE.ASSET.IOS": "iOS",
    "3D.ASSET.WEB": "web",
    "3D.ASSET.MOBILE": "mobile",
    "3D.ASSET.STANDALONE.VR": "standalonevr",
    "3D.ASSET.DESKTOP": "desktop",
    "3D.ASSET.DESKTOP.VR": "desktopvr",
    "3D.ASSET.UNIVERSAL": "universal",
    "3D.ASSET.MACOS": "macOS",
    "3D.ASSET.IOS": "iOS",
}

export const debounce = (func, delay, setLoading) => {
    let timer;
    return function (...args) {
      setLoading(true);
      clearTimeout(timer);
      timer = setTimeout(() => func.apply(this, args), delay);
    };
  };

export const BtnLoading = () => {
    return (
        <div className='btnload'>
            <div className="loader">
                <span className="bar"></span>
                <span className="bar"></span>
                <span className="bar"></span>
            </div>
        </div>
  )
}

export const formatSize = (bytes) => {
    if (bytes >= 1048576) {
        return (bytes / 1048576).toFixed(2) + " MB";
    } else if (bytes >= 1024) {
        return (bytes / 1024).toFixed(2) + " KB";
    } else {
        return bytes + " bytes";
    }
  };

export const getAllXRModuleTags = async () => {
    try {
        let _config = store.getState().configSlice;
        let moduleFilterId = _config?.config?.moduleFilterId;
        let UNO_URL = _config?.config.UNO_URL;

        let data = await apiClient.get(`${UNO_URL}${TAG_LIST}/${moduleFilterId}`);        
        store.dispatch(addModuleXRTags(data)) ;

    } catch (error) {
        console.log(error);
    }

}

export const getAssetTagsList = async (assetFilterId) => {
    try {
        let _config = store.getState().configSlice;
        let UNO_URL = _config?.config.UNO_URL;
        let data = await apiClient.get(`${UNO_URL}${TAG_LIST}/${assetFilterId}`);        
        store.dispatch(addAssetTags(data));
               
    } catch (error) {
         console.log(error);
    }
}

export const moduleTagCategoryWithTags = () => {

    const result = { categories: [] };

    const categoriesConfig = [
        { name: 'Sectors', key: '_sectorsList' },
        { name: 'Packages', key: '_packagesList' },
        { name: 'Job Roles', key: '_jobRolesTags' },
        { name: 'Languages', key: '_languagesTags' },
        { name: 'Difficulty Level', key: '_difficultyLevelTags' },
        { name: 'Validated By', key: '_ValidatedByLevelTags' },
    ];

    const allTagCategoryList = store.getState().tagsSlice?.allTagsList?.children || [];

    categoriesConfig.forEach(({ name, key }) => {
        const category = allTagCategoryList.find(item => item.name === name);

        result[key] = category?.tags?.map(tag => ({
            label: tag.name,
            value: tag.id,
            categoryId: category.id,
        })) || [];
        
        result.categories.push(category);

    });

    return result;

}

export const createNewCustomTags = (props) => {
    const { innerProps, selectProps, customName, type } = props;
    
    const handleCreateNewTag = async() => {
        let UNO_URL = store.getState().configSlice?.config.UNO_URL;
        let tagSliceName =  type === "SKILL_STREAM" ? "skillStream2D" : "allTagsList";
        const _findCategory = store.getState().tagsSlice?.[tagSliceName]?.children?.find(item => item.name === `${customName}`);
        let createTag = {
            "name": selectProps.inputValue,
            "categoryId": _findCategory.id
        }

        try {
            await apiClient.post(`${UNO_URL}${CREATE_TAG}`, createTag);
            getAllXRModuleTags();
        } catch (error) {
            console.log(error);
        }

    };

    return (
        <>
            <div className='nodatafoundbtn' {...innerProps}>
                <p>No options found.</p>
                <button onClick={handleCreateNewTag}>Create This Tag</button>
            </div>
        </>
    );
};

export const createNewAssetTags = (props) => {
    const { innerProps, selectProps, customName } = props;
    
    const handleCreateNewTag = async() => {
        let UNO_URL = store.getState().configSlice?.config.UNO_URL;
        
        let _token = store.getState().userSlice.token

        const _findCategory = store.getState().tagsSlice?.assetTagsList?.children?.find(item => item.name === customName);
        
        let createTag = {
            "name": selectProps.inputValue,
            "categoryId": _findCategory.id
        }

        try {
            await apiClient.post(`${UNO_URL}${CREATE_TAG}`, createTag);
        } catch (error) {
            console.log(error);
        }

        getAssetTagsList(assetFilterId);

    };

    return (
        <>
            <div className='nodatafoundbtn' {...innerProps}>
                <p>No options found.</p>
                <button onClick={handleCreateNewTag}>Create This Tag</button>
            </div>
        </>
    );
};

export const threeDAssetType = [
    {
        "name": "Web",
        "key": "web",
        types: [
            {
                "key": "addressable",
                "name": "Addressable",
                types: [
                    {
                        "key": "Level 0",
                        "name": "Level 0",
                        url: null,
                        loading: false,
                        fileName: null,
                        fileSize: null
                    },
                    {
                        "key": "Level 1",
                        "name": "Level 1",
                        url: null,
                        loading: false,
                        fileName: null,
                        fileSize: null
                    },
                    {
                        "key": "Level 2",
                        "name": "Level 2",
                        url: null,
                        loading: false,
                        fileName: null,
                        fileSize: null
                    },
                ]
            },
            {
                "key": "ab",
                "name": "Asset Bundle",
                types: [
                    {
                        "key": "Level 0",
                        "name": "Level 0",
                        url: null,
                        loading: false,
                        fileName: null,
                        fileSize: null
                    },
                    {
                        "key": "Level 1",
                        "name": "Level 1",
                        url: null,
                        loading: false,
                        fileName: null,
                        fileSize: null
                    },
                    {
                        "key": "Level 2",
                        "name": "Level 2",
                        url: null,
                        loading: false,
                        fileName: null,
                        fileSize: null
                    },
                ]
            }
        ]
    },
    {
        "name": "Mobile",
        "key": "mobile",
        types: [
            {
                "key": "addressable",
                "name": "Addressable",
                types: [
                    {
                        "key": "Level 0",
                        "name": "Level 0",
                        url: null,
                        loading: false,
                        fileName: null,
                        fileSize: null
                    },
                    {
                        "key": "Level 1",
                        "name": "Level 1",
                        url: null,
                        loading: false,
                        fileName: null,
                        fileSize: null
                    },
                    {
                        "key": "Level 2",
                        "name": "Level 2",
                        url: null,
                        loading: false,
                        fileName: null,
                        fileSize: null
                    },
                ]
            },
            {
                "key": "ab",
                "name": "Asset Bundle",
                types: [
                    {
                        "key": "Level 0",
                        "name": "Level 0",
                        url: null,
                        loading: false,
                        fileName: null,
                        fileSize: null
                    },
                    {
                        "key": "Level 1",
                        "name": "Level 1",
                        url: null,
                        loading: false,
                        fileName: null,
                        fileSize: null
                    },
                    {
                        "key": "Level 2",
                        "name": "Level 2",
                        url: null,
                        loading: false,
                        fileName: null,
                        fileSize: null
                    },
                ]
            }
        ]
    },
    {
        "name": "Desktop",
        "key": "desktop",
        types: [
            {
                "key": "addressable",
                "name": "Addressable",
                types: [
                    {
                        "key": "Level 0",
                        "name": "Level 0",
                        url: null,
                        loading: false,
                        fileName: null,
                        fileSize: null
                    },
                    {
                        "key": "Level 1",
                        "name": "Level 1",
                        url: null,
                        loading: false,
                        fileName: null,
                        fileSize: null
                    },
                    {
                        "key": "Level 2",
                        "name": "Level 2",
                        url: null,
                        loading: false,
                        fileName: null,
                        fileSize: null
                    },
                ]
            },
            {
                "key": "ab",
                "name": "Asset Bundle",
                types: [
                    {
                        "key": "Level 0",
                        "name": "Level 0",
                        url: null,
                        loading: false,
                        fileName: null,
                        fileSize: null
                    },
                    {
                        "key": "Level 1",
                        "name": "Level 1",
                        url: null,
                        loading: false,
                        fileName: null,
                        fileSize: null
                    },
                    {
                        "key": "Level 2",
                        "name": "Level 2",
                        url: null,
                        loading: false,
                        fileName: null,
                        fileSize: null
                    },
                ]
            }
        ]
    },
    {
        "name": "Desktop VR",
        "key": "desktopvr",
        types: [
            {
                "key": "addressable",
                "name": "Addressable",
                types: [
                    {
                        "key": "Level 0",
                        "name": "Level 0",
                        url: null,
                        loading: false,
                        fileName: null,
                        fileSize: null
                    },
                    {
                        "key": "Level 1",
                        "name": "Level 1",
                        url: null,
                        loading: false,
                        fileName: null,
                        fileSize: null
                    },
                    {
                        "key": "Level 2",
                        "name": "Level 2",
                        url: null,
                        loading: false,
                        fileName: null,
                        fileSize: null
                    },
                ]
            },
            {
                "key": "ab",
                "name": "Asset Bundle",
                types: [
                    {
                        "key": "Level 0",
                        "name": "Level 0",
                        url: null,
                        loading: false,
                        fileName: null,
                        fileSize: null
                    },
                    {
                        "key": "Level 1",
                        "name": "Level 1",
                        url: null,
                        loading: false,
                        fileName: null,
                        fileSize: null
                    },
                    {
                        "key": "Level 2",
                        "name": "Level 2",
                        url: null,
                        loading: false,
                        fileName: null,
                        fileSize: null
                    },
                ]
            }
        ]
    },
    {
        "name": "Standalone VR",
        "key": "standalonevr",
        types: [
            {
                "key": "addressable",
                "name": "Addressable",
                types: [
                    {
                        "key": "Level 0",
                        "name": "Level 0",
                        url: null,
                        loading: false,
                        fileName: null,
                        fileSize: null
                    },
                    {
                        "key": "Level 1",
                        "name": "Level 1",
                        url: null,
                        loading: false,
                        fileName: null,
                        fileSize: null
                    },
                    {
                        "key": "Level 2",
                        "name": "Level 2",
                        url: null,
                        loading: false,
                        fileName: null,
                        fileSize: null
                    },
                ]
            },
            {
                "key": "ab",
                "name": "Asset Bundle",
                types: [
                    {
                        "key": "Level 0",
                        "name": "Level 0",
                        url: null,
                        loading: false,
                        fileName: null,
                        fileSize: null
                    },
                    {
                        "key": "Level 1",
                        "name": "Level 1",
                        url: null,
                        loading: false,
                        fileName: null,
                        fileSize: null
                    },
                    {
                        "key": "Level 2",
                        "name": "Level 2",
                        url: null,
                        loading: false,
                        fileName: null,
                        fileSize: null
                    },
                ]
            }
        ]
    },
    {
        "name": "Mac OS",
        "key": "macOS",
        types: [
            {
                "key": "addressable",
                "name": "Addressable",
                types: [
                    {
                        "key": "Level 0",
                        "name": "Level 0",
                        url: null,
                        loading: false,
                        fileName: null,
                        fileSize: null
                    },
                    {
                        "key": "Level 1",
                        "name": "Level 1",
                        url: null,
                        loading: false,
                        fileName: null,
                        fileSize: null
                    },
                    {
                        "key": "Level 2",
                        "name": "Level 2",
                        url: null,
                        loading: false,
                        fileName: null,
                        fileSize: null
                    },
                ]
            },
            {
                "key": "ab",
                "name": "Asset Bundle",
                types: [
                    {
                        "key": "Level 0",
                        "name": "Level 0",
                        url: null,
                        loading: false,
                        fileName: null,
                        fileSize: null
                    },
                    {
                        "key": "Level 1",
                        "name": "Level 1",
                        url: null,
                        loading: false,
                        fileName: null,
                        fileSize: null
                    },
                    {
                        "key": "Level 2",
                        "name": "Level 2",
                        url: null,
                        loading: false,
                        fileName: null,
                        fileSize: null
                    },
                ]
            }
        ]
    },
    {
        "name": "iOS",
        "key": "iOS",
        types: [
            {
                "key": "addressable",
                "name": "Addressable",
                types: [
                    {
                        "key": "Level 0",
                        "name": "Level 0",
                        url: null,
                        loading: false,
                        fileName: null,
                        fileSize: null
                    },
                    {
                        "key": "Level 1",
                        "name": "Level 1",
                        url: null,
                        loading: false,
                        fileName: null,
                        fileSize: null
                    },
                    {
                        "key": "Level 2",
                        "name": "Level 2",
                        url: null,
                        loading: false,
                        fileName: null,
                        fileSize: null
                    },
                ]
            },
            {
                "key": "ab",
                "name": "Asset Bundle",
                types: [
                    {
                        "key": "Level 0",
                        "name": "Level 0",
                        url: null,
                        loading: false,
                        fileName: null,
                        fileSize: null
                    },
                    {
                        "key": "Level 1",
                        "name": "Level 1",
                        url: null,
                        loading: false,
                        fileName: null,
                        fileSize: null
                    },
                    {
                        "key": "Level 2",
                        "name": "Level 2",
                        url: null,
                        loading: false,
                        fileName: null,
                        fileSize: null
                    },
                ]
            }
        ]
    },
    {
        "name": "Universal",
        "key": "universal",
        types: [
            {
                "key": "fbx",
                "name": "FBX",
                types: [
                    {
                        "key": "fbx",
                        "name": "FBX",
                        url: null,
                        loading: false,
                        fileName: null,
                        fileSize: null
                    }
                ]
            },
            {
                "key": "gltf",
                "name": "GLTF",
                types: [
                    {
                        "key": "gltf",
                        "name": "GLTF",
                        url: null,
                        loading: false,
                        fileName: null,
                        fileSize: null
                    }
                ]
            },
            {
                "key": "glb",
                "name": "GLB",
                types: [
                    {
                        "key": "glb",
                        "name": "GLB",
                        url: null,
                        loading: false,
                        fileName: null,
                        fileSize: null
                    }
                ]
            },
            {
                "key": "gfb",
                "name": "GFB",
                types: [
                    {
                        "key": "gfb",
                        "name": "GFB",
                        url: null,
                        loading: false,
                        fileName: null,
                        fileSize: null
                    }
                ]
            }
        ]
    },
]


export const assetsTag3DResourceLists = async() => {
    let children = store.getState().tagsSlice?.assetTagsList?.children || [];
    let result = {};
    children.forEach(item => {
        result[item.name] = item.tags.map(tag => ({
            label: tag.name,
            value: tag.id,
            categoryId: tag.categoryId
              }));
        });

    return result
}

export const verifyImageResolution = async(file, acceptWidth=1280, acceptHeight=720) =>{
    return new Promise((resolve, reject) => {
    const image = new Image();
    image.src = URL.createObjectURL(file);

    image.onload = async() => {
      const { width, height } = image;
      if ((width <=(acceptWidth+10) && width >= (acceptWidth-10)) && ( height <= (acceptHeight+10) || height >= (acceptHeight-10) )) {
          URL.revokeObjectURL(image.src);
          resolve(true);
        } else {
          toastError(`Incorrect resolution. Expected ${acceptWidth}*${acceptHeight}`);
          console.error("Incorrect resolution. Expected 1280x720, but got:", width, height);
          URL.revokeObjectURL(image.src);
          resolve(false);
        }
    }
    image.onerror = () => {
        toastError("Error in file upload.");
        console.error("Error in file upload.");
        URL.revokeObjectURL(image.src);
         resolve(false);
      };
   });
}